// mappings for admin navbar menus and routes
import urls from 'src/utils/urls';
import {
  FEATURE_FLAGS,
  MANAGE_COLLEGE_RANKS,
  MANAGE_INTERNAL_USERS,
  MANAGE_SFTP_USERS,
} from '../constants';

const menus = [
  {
    title: 'Edit Institutions',
    menuItems: [
      {title: 'Colleges', path: '/admin/college-listings', routed: true},
      {title: 'High Schools', path: '/admin/high_schools', routed: false},
      {title: 'Districts', path: '/admin/districts', routed: false},
      {title: 'Access Orgs', path: '/admin/tools/access-organizations', routed: true},
      {
        title: 'Community College Search',
        path: '/admin/tools/community-college-search',
        routed: true,
      },
    ],
  },
  {
    title: 'Users',
    menuItems: [
      {title: 'Hallway Monitor', path: '/admin/tools/hallway-monitor', routed: true},
      {title: 'Create New Users', path: '/admin/hallway-monitor/new', routed: false},
      {path: '/admin/tools/college-portal-users', title: 'College Portal Users', routed: true},
      {title: 'Educator Verification', path: '/admin/tools/educator-verification', routed: false},
      {title: 'Educator Inspection', path: '/admin/tools/educator-inspection', routed: false},
      {title: 'District Admins', path: '/admin/tools/district-admins', routed: true},
      {
        title: 'Internal Users',
        path: '/admin/tools/internal-users',
        routed: true,
        requiresAnyFeatureFlag: [MANAGE_INTERNAL_USERS],
      },
    ],
  },
  {
    title: 'Features',
    menuItems: [
      {
        title: 'Feature Flags',
        path: '/admin/tools/feature-flags',
        requiresAnyFeatureFlag: ['editingFeatureFlags'],
        routed: true,
      },
      {title: 'Experiments', path: '/admin/experiments', routed: false},
      {title: 'Toolbar', path: '/admin/tools/toolbar-notifications', routed: true},
      {title: 'CatTag', path: '/admin/cattag', routed: false},
      {title: 'Breaking Changes', path: '/admin/breaking_change', routed: false},
    ],
  },
  {
    title: 'Jobs',
    menuItems: [
      {title: 'Sidekiq', path: '/admin/sidekiq', routed: false},
      {path: '/admin/tools/scheduled-jobs', title: 'Scheduled', routed: true},
    ],
  },
  {
    title: 'Tools',
    menuItems: [
      {
        path: '/admin/tools/time-sensitive-item-types',
        title: 'Time Sensitive Item Types',
        routed: true,
      },
      {path: '/admin/tools/ugss', title: 'UGSS', routed: true},
      {path: '/admin/tools/upload-file', title: 'Upload', routed: true},
      {path: '/admin/tools/resource-sections', title: 'Resources', routed: true},
      {path: '/admin/tools/common-tests', title: 'Common Tests', routed: true},
      {path: '/admin/tools/course-listings', title: 'Course Listings', routed: true},
      {path: '/admin/tools/college-majors', title: 'College Majors', routed: true},
      {
        path: '/admin/tools/college-ranks',
        title: 'College Ranks',
        routed: true,
        requiresAnyFeatureFlag: [MANAGE_COLLEGE_RANKS],
      },
      {path: '/admin/tools/honors-and-awards', title: 'Honors and Awards', routed: true},
      {
        path: '/admin/tools/sftp-users',
        title: 'SFTP Users',
        routed: true,
        requiresAnyFeatureFlag: [MANAGE_SFTP_USERS],
      },
      {
        path: '/admin/tools/experience-everywhere-tenants',
        title: 'Experience Everywhere Tenants',
        routed: true,
      },
      {
        path: '/admin/tools/partner-provisioning',
        title: 'Partner Provisioning',
        routed: true,
      },
      {
        path: '/admin/tools/scheduled-reports',
        title: 'Scheduled Reports',
        routed: true,
        requiresAnyFeatureFlag: ['editingFeatureFlags'],
      },
    ],
  },
];

const featureFlags = [...FEATURE_FLAGS, 'editing_feature_flags', MANAGE_INTERNAL_USERS];

const avatarMenuItems = [{title: 'Sign out', path: urls.logout, routed: false}];

export const navElements = {
  menus,
  avatarMenuItems,
  featureFlags,
};
